// Formato de fecha (mexico)

import { format } from "date-fns";

export const formatMX = (date) => new Date(date).toLocaleDateString("es-MX");
export const formatMXddMM = (date) => {
  // console.log('formatMXddMM', date);
  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = String(d.getFullYear()).padStart(4, "0");

  return `${day}/${month}/${year}`;
};

export const formatMXDateTime = (date) => {
  return new Date(date).toLocaleString("es-MX", {
    hour12: false,
  });
};

export const formatMXDateTimeNoSeconds = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleString("es-MX", {
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDashedDate = (date) =>
  format(new Date(date), "yyyy-MM-dd");

export const formatMXDayString = (date) => date.toLocaleDateString("es-MX", { weekday: "short" });
